import React from 'react';
import styled from 'styled-components';

// Krafteo "avant / après": three hand-kept copies of the same data shapes vs. one
// shared source every surface refers to. Dark-theme port of the print portfolio.
const Wrap = styled.div`
  display: flex;
  gap: 18px;
  margin-top: 18px;

  @media (max-width: 640px) {
    flex-direction: column;
  }

  .side {
    display: flex;
    flex: 1;
    min-width: 0;
    flex-direction: column;
    padding: 20px;
    background: var(--light-navy);
    border: 1px solid var(--lightest-navy);
    border-radius: var(--border-radius);
  }
  .side.after {
    background: var(--green-tint);
    border-color: rgba(100, 255, 218, 0.4);
  }

  .tag {
    margin-bottom: 16px;
    font-family: var(--font-mono);
    font-size: var(--fz-xs);
    font-weight: 700;
    letter-spacing: 0.1em;
    text-transform: uppercase;
  }
  .tag.bad {
    color: #ff8f8f;
  }
  .tag.good {
    color: var(--green);
  }

  .box {
    padding: 10px 14px;
    margin-bottom: 10px;
    background: var(--navy);
    border: 1px solid var(--lightest-navy);
    border-radius: var(--border-radius);
  }
  .box b {
    display: block;
    color: var(--lightest-slate);
    font-size: var(--fz-sm);
    font-weight: 600;
  }
  .box span {
    display: block;
    margin-top: 3px;
    color: var(--slate);
    font-size: var(--fz-xs);
  }
  .box.src {
    text-align: center;
    border-color: var(--green);
  }
  .box.src b {
    color: var(--green);
  }

  .arrows {
    display: flex;
    margin: 4px 0 10px;
    span {
      flex: 1;
      text-align: center;
      color: var(--green);
      line-height: 1;
    }
  }
  .row {
    display: flex;
    gap: 8px;
    .box {
      flex: 1;
      min-width: 0;
      margin-bottom: 0;
      text-align: center;
    }
  }

  .foot {
    margin-top: auto;
    padding-top: 16px;
    font-size: var(--fz-sm);
    line-height: 1.45;
  }
  .foot.bad {
    color: #ff9c9c;
  }
  .foot.good {
    color: var(--green);
    font-weight: 600;
  }
`;

export const SharedContractDiagram = () => (
  <Wrap>
    <div className="side">
      <div className="tag bad">Avant</div>
      <div className="box">
        <b>Serveur</b>
        <span>décrit les données</span>
      </div>
      <div className="box">
        <b>Site web</b>
        <span>les redécrit de son côté</span>
      </div>
      <div className="box">
        <b>Mobile</b>
        <span>les redécrit encore</span>
      </div>
      <div className="foot bad">
        Trois descriptions du même objet, tenues d&apos;accord à la main.
      </div>
    </div>

    <div className="side after">
      <div className="tag good">Après</div>
      <div className="box src">
        <b>Une seule description</b>
        <span>partagée par tout le produit</span>
      </div>
      <div className="arrows">
        <span>↑</span>
        <span>↑</span>
        <span>↑</span>
      </div>
      <div className="row">
        <div className="box">
          <b>Serveur</b>
        </div>
        <div className="box">
          <b>Web</b>
        </div>
        <div className="box">
          <b>Mobile</b>
        </div>
      </div>
      <div className="foot good">Les trois s&apos;y réfèrent. Elles ne peuvent plus diverger.</div>
    </div>
  </Wrap>
);
